import { connect } from 'react-redux';
import GateLayoutComponent from '../components/GateLayout/GateLayout';

const GateLayout = connect(state => state)(GateLayoutComponent);

export default GateLayout;
